import React  from 'react';
export default function PlanificacionDash(){

    return(
        <>
            <h1>Dashboard Planificacion</h1>
        </>
    );
}